import "/node_modules/flag-icons/css/flag-icons.min.css";
const LanguageFlag = ({ code, className }) => {
  return <span className={`fi fi-${code?.toLowerCase()}  ${className}`} />;
};

export default LanguageFlag;
